import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import rbacService from "../../services/rbacService";

const initialState = {
  permissions: [],
  /** null = not loaded / legacy (treat all modules as enabled) */
  enabledModules: null,
  loading: false,
  error: null,
};

export const fetchMyPermissions = createAsyncThunk(
  "permissions/fetchMy",
  async (_, { rejectWithValue }) => {
    try {
      const response = await rbacService.getMyPermissions();
      const data = response?.data?.data ?? response?.data ?? response;
      const permissions = Array.isArray(data?.permissions) ? data.permissions : [];
      const enabledModules = Array.isArray(data?.enabledModules)
        ? data.enabledModules
        : null;
      return { permissions, enabledModules };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch permissions"
      );
    }
  }
);

const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    clearPermissions: (state) => {
      state.permissions = [];
      state.enabledModules = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyPermissions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMyPermissions.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload;
        if (payload && typeof payload === "object" && !Array.isArray(payload)) {
          state.permissions = payload.permissions || [];
          state.enabledModules = payload.enabledModules ?? null;
        } else {
          state.permissions = Array.isArray(payload) ? payload : [];
          state.enabledModules = null;
        }
        state.error = null;
      })
      .addCase(fetchMyPermissions.rejected, (state, action) => {
        state.loading = false;
        state.permissions = [];
        state.enabledModules = null;
        state.error = action.payload || "Failed to fetch permissions";
      });
  },
});

export const { clearPermissions } = permissionsSlice.actions;
export default permissionsSlice.reducer;
